import Button, { ButtonProps } from 'ui/Buttons/Button/Button';
import { forwardRef } from 'react';
import cn from 'classnames';
import styles from './ActionButton.module.css';

type Props = ButtonProps & {
    isError?: boolean;
};

const ActionButton = forwardRef<HTMLButtonElement, Props>(({ isError, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            {...props}
            type="bordered"
            className={cn(styles.actionButton, { [styles.error]: isError }, props.className)}
        />
    );
});

export default ActionButton;
